<div class="panel panel-default">
  <div class="panel-heading">
    <b class="panel-title" [innerHTML]="title"></b>
  </div>
  <div class="panel-body">
    <span [innerHTML]="text"></span>
    <div style="    display: flex;    flex-direction: column;
    align-items: end;
    gap: 10px;">
      <div>
        Click here to print these instructions for reference:
        <button (click)="print()" class="btn btn-default">Print</button>
      </div>
      <div>
        Click here to start your new or renewal application:
        <button (click)="application.startApplication(application_type)" class="btn btn-default">Start</button>
      </div>
    </div>
  </div>
</div>
